import { useCallback, useEffect, useState } from 'react';

import { useUserContext } from '@collab/features/user';

import { ApiOption } from 'features/test-access-tokens/test-access-tokens.types';
import { parseData } from 'libs/api';
import { normalizeApiInfo } from 'libs/apim/normalizeData';
import { nextServerAuthFetch } from 'libs/auth-fetch';
import { ApiInfo } from 'libs/cms/common/types';
import { usesAuthorizationCodeFlow } from 'utils/resourceChecks';

const useApiOptions = () => {
  const { isLoggedIn, isUserStatusLoading } = useUserContext();
  const [apiOptions, setApiOptions] = useState<ApiOption[]>([]);

  const getApiOptions = useCallback(async () => {
    let response;

    if (isLoggedIn) {
      response = await nextServerAuthFetch('/api/apim/apis');
    } else {
      response = await fetch('/api/apim/apis/public');
    }

    const data = await parseData(response, 200);

    const apiInfos: ApiInfo[] = data.apis.map(normalizeApiInfo);

    const options = apiInfos
      .filter((api) => usesAuthorizationCodeFlow(api.apiAuthMethod))
      .map(toApiOption);

    setApiOptions(options);
  }, [isLoggedIn]);

  useEffect(() => {
    if (!isUserStatusLoading) {
      getApiOptions();
    }
  }, [isLoggedIn, isUserStatusLoading, getApiOptions]);

  return apiOptions;
};

const toApiOption = ({ id, title }: ApiInfo): ApiOption => ({
  key: id,
  name: title,
});

export default useApiOptions;
